import { render, staticRenderFns } from "./BowDetailsBlock.vue?vue&type=template&id=d5af1aae&"
import script from "./BowDetailsBlock.vue?vue&type=script&lang=js&"
export * from "./BowDetailsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowAnimation: require('/workspace/components/base/BowAnimation/BowAnimation.vue').default,BowFeatureGroup: require('/workspace/components/molecules/BowFeatureGroup/BowFeatureGroup.vue').default,BowWrapper: require('/workspace/components/base/BowWrapper/BowWrapper.vue').default})
